// extracted by mini-css-extract-plugin
export default {"float":"index_float_zK2lj","active":"index_active_BAAQf"};